import React from "react";
import "./index.scss";

export default function ContentBlock(props) {
  const { className, text } = props;
  return (
    <div className={`content_block ${className ? className : ""}`}>{text}</div>
  );
}
